import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { playerDisplayName } from "./PlayerDisplayNameLink";
import { TallyMark } from "../common/TallyMark";
export const PlayerAvatar = ({ player, pictureUrl, name, playerId, size = 56, disableLink = false, verified = false, }) => {
    const displayName = player ? playerDisplayName(player) : name ?? "";
    const picture = player ? player.user?.picture : pictureUrl;
    const id = player ? player.id : playerId;
    // A registered avatar keeps the SAME outer footprint as a plain one so names
    // stay left-aligned down a mixed list: the gradient ring + gap is inset by
    // shrinking the photo, rather than growing the overall size.
    const RING = 2.5;
    const GAP = 1.5;
    const innerSize = verified ? Math.max(0, size - 2 * (RING + GAP)) : size;
    const avatar = (_jsx(Avatar, { src: picture ?? undefined, alt: displayName, sx: { width: innerSize, height: innerSize }, children: displayName.match(/\b(\w)/g)?.join("") }));
    // Badge scales gently with the avatar (so it isn't oversized on a big profile
    // avatar) but is floored so it stays legible on small list rows.
    const badgeSize = Math.max(16, Math.round(size * 0.33));
    // Registered "real athlete": a brand gradient ring (navy→gold, à la Strava's
    // athlete ring) with a thin surface-coloured gap, plus the tally badge.
    const content = verified ? (_jsxs(Box, { sx: { position: "relative", display: "inline-flex" }, children: [_jsx(Box, { sx: {
                    p: `${RING}px`,
                    borderRadius: "50%",
                    display: "inline-flex",
                    // navy→gold→navy so the ring reads like a medal rim catching light,
                    // not a flat two-tone split.
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 55%, ${theme.palette.primary.main} 100%)`,
                }, children: _jsx(Box, { sx: {
                        p: `${GAP}px`,
                        borderRadius: "50%",
                        display: "inline-flex",
                        bgcolor: "background.paper",
                    }, children: avatar }) }), _jsx(Box, { role: "img", "aria-label": "Registered athlete", sx: {
                    position: "absolute",
                    // Top-right, sitting just off the avatar's edge (minimal overlap).
                    top: "10%",
                    left: "90%",
                    transform: "translate(-50%, -50%)",
                    width: badgeSize,
                    height: badgeSize,
                    borderRadius: "50%",
                    // Navy chip + white mark (the exact logo outline), with a white ring
                    // to lift it off the avatar.
                    bgcolor: "primary.main",
                    color: "#fff",
                    border: "1.5px solid #fff",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.35)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, children: _jsx(TallyMark, { size: Math.round(badgeSize * 0.5) }) })] })) : (avatar);
    const tooltip = (_jsx(Tooltip, { title: displayName, arrow: true, children: content }));
    if (id === undefined || disableLink) {
        return tooltip;
    }
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/players/${id}/`, children: tooltip }, id));
};
